module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/lizard_BW-ef418370c34d8263f15818961a011df8.jpg";